export default __webpack_public_path__ + "static/media/NotoSans-Bold.97724077.eot";